// extracted by mini-css-extract-plugin
export default {"root":"ResetPasswordFailedSection_root__znDV0","heading":"ResetPasswordFailedSection_heading__CbgsG","verifiedText":"ResetPasswordFailedSection_verifiedText__VbQvr"};